/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Check_In_Not_Eligible_DescriptionInputs */

const en_check_in_not_eligible_description = /** @type {(inputs: Check_In_Not_Eligible_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This account is not eligible for additional promotional credits. Your existing credits are unchanged.`)
};

const es_check_in_not_eligible_description = /** @type {(inputs: Check_In_Not_Eligible_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta cuenta no puede recibir creditos promocionales adicionales. Tus creditos actuales no cambian.`)
};

/**
* | output |
* | --- |
* | "This account is not eligible for additional promotional credits. Your existing credits are unchanged." |
*
* @param {Check_In_Not_Eligible_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const check_in_not_eligible_description = /** @type {((inputs?: Check_In_Not_Eligible_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Check_In_Not_Eligible_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_check_in_not_eligible_description(inputs)
	return es_check_in_not_eligible_description(inputs)
});